export enum ReviewedMixpanelEvents {
    USER_LOGGED_IN = 'user_logged_in',
    DEPOSIT_STARTED = 'deposit_started',
    DEPOSIT_COMPLETED = 'deposit_completed',
    DEPOSIT_FAILED = 'deposit_failed',
    PAGE_VIEWED = 'page_viewed',
    PAGE_LANDED = 'page_landed',
    PAYOUT_CTA_CLICKED = 'payout_cta_clicked',
    // RAF (Refer & Earn) events
    RAF_LINK_COPIED = 'raf_link_copied',
    RAF_SOCIAL_SHARE_CLICKED = 'raf_social_share_clicked',
    RAF_TIME_FILTER_CHANGED = 'raf_time_filter_changed',
    RAF_TOOLTIP_OPENED = 'raf_tooltip_opened',
    RAF_TERMS_LINK_CLICKED = 'raf_terms_link_clicked',
    RAF_CTA_TRIGGERED = 'raf_cta_triggered',
    RAF_POPUP_ERROR = 'raf_popup_error',
    RAF_POPUP_VIEWED = 'raf_popup_viewed',
}
